import { FC } from 'react';

import { TableSection } from '../Table/Table.types';
import { TableBodyStyled } from './TableBody.styles';
import { TableBodyProps } from './TableBody.types';

import TableSectionContextProvider from '../Table/TableSectionContext';

const TableBody: FC<TableBodyProps> = ({ children }) => {
  return (
    <TableSectionContextProvider value={{ variant: TableSection.BODY }}>
      <TableBodyStyled>{children}</TableBodyStyled>
    </TableSectionContextProvider>
  );
};

export default TableBody;
